import { useRef, useEffect } from 'react';

function useClickAway(ref, callback) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;
  const isInsideClickRef = useRef(false);
  useEffect(() => {
    if (!ref.current) {
      return;
    }
    const node = ref.current;
    const onElementClick = () => {
      isInsideClickRef.current = true;
    };
    const onDocumentClick = (event) => {
      if (isInsideClickRef.current) {
        isInsideClickRef.current = false;
      } else {
        callbackRef.current?.(event);
      }
    };
    node.addEventListener("mousedown", onElementClick, true);
    document.addEventListener("mousedown", onDocumentClick);
    return () => {
      node.removeEventListener("mousedown", onElementClick, true);
      document.removeEventListener("mousedown", onDocumentClick);
    };
  }, [callbackRef, isInsideClickRef, ref]);
}

export { useClickAway };
